/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     成员管理 API 接口
  | @Version:   2020-02-12  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApi = process.env.VUE_APP_GENERAL_API_HOST;

export function relaterListApi(query) {
  return request({
    url: '?c=fam&a=relater&do=list',
    method: 'get',
    params: query
  })
}

export function wechatFanGetfewApi(query) {
  return request({
    url: '?c=up&a=member&do=getfew',
    method: 'get',
    params: query
  })
}

export function postRelaterApi(data) {
  return request({
    url: generalApi + '/fam/relater/post',
    method: 'post',
    data
  })
}

export function delRelaterApi(data) {
  return request({
    url: generalApi + '/fam/relater/delete',
    method: 'post',
    data
  })
}

export function noticeApi(data) {
  return request({
    url: '?c=fam&a=relater&do=notice',
    method: 'post',
    data: data
  })
}

export function roleGetallApi(params) {
  return request({
    url: generalApi + '/god/role/getall',
    method: 'get',
    params
  })
}

export function roleGetApi(params) {
  return request({
    url: generalApi + '/god/role/get',
    method: 'get',
    params
  })
}

export function rolePostApi(data) {
  return request({
    url: generalApi + '/god/role/post',
    method: 'post',
    data
  })
}

export function roleDeleteApi(data) {
  return request({
    url: generalApi + '/god/role/delete',
    method: 'post',
    data
  })
}
